import ApiService from "src/shared/utils/base-api/api-service";
import { ResponseDto } from "src/shared/common-dtos/response-dto";
import {
  ChatMessageDto,
  ChatRoomDto,
  GetMessagesDto,
  GetUserChatRoomsDto,
  MarkRoomAsReadDto,
  SendMessageDto,
} from "./dto";
import { DataListDto } from "../../common-dtos/data-list-dto";

class ChatService extends ApiService {
  constructor() {
    super({
      baseURL: "/Chat",
    });
  }

  public getUserChatRooms(
    input?: GetUserChatRoomsDto,
  ): Promise<ResponseDto<DataListDto<ChatRoomDto>>> {
    return this.get("/GetUserChatRooms", { params: input });
  }

  public getMessages(
    input: GetMessagesDto,
  ): Promise<ResponseDto<DataListDto<ChatMessageDto>>> {
    return this.get(`/GetChatMessages/${input.roomId}`, { params: input });
  }

  public sendMessage(
    input: SendMessageDto,
  ): Promise<ResponseDto<ChatMessageDto>> {
    return this.post("/SendMessage", input);
  }

  public markRoomAsRead(input: MarkRoomAsReadDto): Promise<ResponseDto<void>> {
    return this.put(`/MarkRoomAsRead/${input.roomId}`);
  }

  public deleteMessage(messageId: string): Promise<ResponseDto<void>> {
    return this.delete(`/DeleteMessage/${messageId}`);
  }

  public searchMessages(
    roomId: string,
    searchText: string,
  ): Promise<ResponseDto<ChatMessageDto[]>> {
    return this.get("/SearchMessages", {
      params: { roomId, searchText },
    });
  }
}

export const chatService = new ChatService();
